import { AloftDate, orUndefined } from '@aloft/toolkit-shared';

import { getAloftDateFromRawString } from './getAloftDateFromRawString.ts';

export function extractEffectiveDate(doc: Document): AloftDate | undefined {
  try {
    const rawEffectiveDate =
      doc?.getElementsByTagName('VALUATION')[0]?.getAttribute('AppraisalEffectiveDate') ??
      undefined;
    return orUndefined(getAloftDateFromRawString)(rawEffectiveDate);
  } catch (e: unknown) {
    console.warn('Failed to parse effective date', e);
    return undefined;
  }
}
